import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Rodape from '../rodape.js';
import {extractUTMTags} from '../utm_tags.js';
import { Header } from '../header.js';
import './account_common.css';

const utmTags = extractUTMTags();

function VerifyAccount() {

  const Navigate = useNavigate();

  const handleVerification = () => {
    Navigate(`/logon`);
  };

  const [isMobile, setIsMobile] = React.useState(false);
  // Function to check if the device is a mobile
  const checkIfMobile = () => {
      const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(isMobileDevice);
  };
  React.useEffect(() => {
      checkIfMobile();
      // Add event listener to check if the device type changes
      window.addEventListener('resize', checkIfMobile);
      // Remove event listener on component unmount
      return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return (
    <>
    <Header isMobile={isMobile}/>
    <div className="auth-container-common">
      <h2>Agora falta verificar seu email</h2>
      <p>Para isso, abra a sua caixa de entrada, procure pelo email enviado para verificação de conta e clique no link enviado.</p>
      <p><b>Depois de fazer isso,</b> clique no botão abaixo para fazer seu primeiro login no site Domínio Elétrico.</p>
      <button type='submit' className="btn-account" onClick={handleVerification}>Já verifiquei</button>
    </div>
    <Rodape />
    </>
  );
}

export default VerifyAccount;
